import { halkbankConfig } from './halkbankConfig';
import { sahibindenConfig } from './sahibindenConfig';
import { synapsConfig } from './synapsConfig';

export const variantRegistry = {
  synaps: synapsConfig,
  sahibinden: sahibindenConfig,
  halkbank: halkbankConfig,
} as const;
